import { useParams } from "react-router-dom";
import { decrypt } from "../utils/encryption";
import { useMemo } from "react";

/**
 * A wrapper around react-router-dom's useParams that automatically decrypts all parameters.
 */
export const useEncryptedParams = () => {
  const params = useParams();

  return useMemo(() => {
    const decryptedParams = {};
    Object.entries(params).forEach(([key, value]) => {
      // We try to decrypt. If decryption fails, it returns empty string or the original (if we want).
      // Based on user requirement "if user write any kind of the data in the url that also it should not work",
      // we should return an invalid value if decryption fails.
      decryptedParams[key] = decrypt(value);
    });
    return decryptedParams;
  }, [params]);
};
